// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1OBHR","container":"styles_container__rGIuY","title":"styles_title__Of33b","wrapper":"styles_wrapper__3nzIU","answer":"styles_answer__3hljC"};